import { createContext, useContext } from 'react'

type OrderCatalogControlValue = {
  openCatalog: () => void
  hasItems: boolean
}

const OrderCatalogControlContext =
  createContext<OrderCatalogControlValue | null>(null)

export const OrderCatalogControlProvider = OrderCatalogControlContext.Provider

export const useOrderCatalogControl = () => {
  const ctx = useContext(OrderCatalogControlContext)
  if (!ctx) {
    throw new Error(
      'useOrderCatalogControl must be used within OrderCatalogControlProvider'
    )
  }
  return ctx
}

/** Safe when catalog is not available (e.g. explore-mode / no quote). */
export const useOptionalOrderCatalogControl = () =>
  useContext(OrderCatalogControlContext)
